import React, { useEffect, useState, lazy } from 'react';
import useAddress from './useAddress';
import addressData from 'src/assets/dataJson/address_data.json';
import restructureData from './StracturedAddressData';
import AddressModal from './AddressModal';
import { useNotif } from 'src/hooks';
import { invalidAddress } from './StracturedAddressData';

const AddressResult = ({
  onEntert,
  onsubmitData,
  openDlg,
  closeDlg,
  subTypeMeta
}) => {
  const formattedData = restructureData(addressData);
  const [openDialog, setOpenDialog] = useState(false);
  const notify = useNotif();

  const { prov, city, barangay, zip, street } = useAddress({
    formattedData,
    onEntert,
    handleSetDelimiter: ','
  });
  const submitValues = () => {
    onsubmitData({
      addProvince: prov,
      addMuniCities: city,
      addBarangays: barangay,
      addZIP: zip,
      addStreet: street
    });
  };

  const emptyValues = () => {
    onsubmitData({
      addProvince: '',
      addMuniCities: '',
      addBarangays: '',
      addZIP: '',
      addStreet: ''
    });
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    closeDlg(false);
  };

  useEffect(() => {
    if (onEntert) {
      const badWords = invalidAddress(
        { word: onEntert, settings: subTypeMeta },
        notify
      );

      if (badWords.length > 0) {
        setOpenDialog(true);
      } else {
        if (prov && (!city || !barangay)) {
          setOpenDialog(true);
        } else if (prov || city || barangay || zip || street) {
          submitValues();
        }
        if (!prov && !city && !barangay) {
          emptyValues();
          setOpenDialog(true);
        }
      }
    } else {
      emptyValues();
    }
  }, [onEntert, prov, city, barangay, zip, street, subTypeMeta]);

  const handleOnsubmitData = data => {
    onsubmitData(data);
  };

  return (
    <>
      {(openDialog || openDlg) && (
        <AddressModal
          formattedData={formattedData}
          openDialog={openDialog}
          openDlg={openDlg}
          closeDialog={handleCloseDialog}
          onEntert={onEntert}
          onsubmitData={handleOnsubmitData}
          subTypeMeta={subTypeMeta}
        />
      )}
    </>
  );
};

export default AddressResult;
